"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  leadtext: {
    "& strong": {
      fontWeight: "bold"
    },
    "& em": {
      fontStyle: "italic"
    }
  }
}));

const ArticleLeadtext = ({
  className,
  language = "no",
  children
}) => {
  const localeId = "locale:" + language;
  const classes = useStyles();

  if (typeof children === "object") {
    children = children[localeId] || undefined;
  }

  return _react.default.createElement(_reactMarkdown.default, {
    className: className || classes.leadtext,
    source: children
  });
};

var _default = ArticleLeadtext;
exports.default = _default;
module.exports = exports.default;